export const getDurationString = (seconds: number) => {
  const _minutes = Math.floor(seconds / 60);
  const _seconds = seconds % 60;

  return `${_minutes ? `${_minutes}m` : ''}${_seconds ? `${_seconds}s` : ''}`;
};
